import { Icon, IconName } from "@zapier/zinnia-icons";
import { Text } from "@zapier/design-system";
import { useTranslations } from "next-intl";
import styles from "./Hero.module.css";
import { CrossDomainImage } from "../CrossDomainImage/CrossDomainImage";
import { BreadCrumbItem, BreadCrumbs } from "../BreadCrumbs/BreadCrumbs";

interface HeroProps {
  title: string;
  description?: string;
  crumbs: BreadCrumbItem[];
  image?: string;
  iconName?: IconName;
}

export const Hero = ({
  title,
  description,
  crumbs,
  image,
  iconName,
}: HeroProps) => {
  const t = useTranslations("TemplateLibrary");
  return (
    <div className={styles.hero}>
      <div className={`${styles.heroContent} ${!image ? styles.noImage : ""}`}>
        <div className={styles.left}>
          <div className={styles.breadcrumbs}>
            {crumbs.length > 1 && <BreadCrumbs crumbs={crumbs} />}
          </div>
          <Text
            type="PageHeader"
            tag="h1"
            className={styles.title}
            color="TextDefault"
          >
            {iconName && (
              <Icon name={iconName} color="BrandOrange" size={40} isBlock />
            )}
            {t("templatesSuffix", { title })}
          </Text>
          <Text type="ParagraphHeader1" color="GrayWarm9">
            {description}
          </Text>
        </div>
        {image && (
          <div className={styles.heroImageContainer}>
            <CrossDomainImage
              src={image}
              alt=""
              priority
              width="591"
              height="350"
            />
          </div>
        )}
      </div>
    </div>
  );
};
